import { render } from "./DictionaryEntryWidget.vue?vue&type=template&id=7150a974&scoped=true"
import script from "./DictionaryEntryWidget.vue?vue&type=script&lang=js"
export * from "./DictionaryEntryWidget.vue?vue&type=script&lang=js"

import "./DictionaryEntryWidget.vue?vue&type=style&index=0&id=7150a974&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7150a974"]])

export default __exports__